import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { translate } from 'parking-react-common'

import { users, routing, ui } from '../redux'

import List from '../components/List'
import Button from '../components/Button'
import UserDisplay from '../components/UserDisplay'
import ButtonGroup from '../components/ButtonGroup'


const UsersList = ({ dataURL, dataSelector, t }) => {
    const columns = [
        {
            key    : 'user',
            title  : t('User'),
            render : ({ rowData }) => ( // eslint-disable-line react/prop-types
                <UserDisplay user={ rowData } />
            )

        },
        {
            key    : 'actions',
            render : ({ rowData }) => ( // eslint-disable-line react/prop-types
                <ButtonGroup>
                    <Button
                        link={ routing.routeFor('users', { id: rowData.id, action: 'edit' }) }
                        icon="md/edit"
                        label={ t('Edit') }
                        intent={ ui.INTENT.warning }
                        isSpaced
                    />
                    <Button
                        link={ routing.routeFor('users', { id: rowData.id, action: 'reset-password' }) }
                        icon="md/vpn-key"
                        label={ t('Reset password') }
                        intent={ ui.INTENT.info }
                        isSpaced
                    />
                </ButtonGroup>
            )
        }
    ]

    const searchKeys = users.getSearchKeys('')

    return (
        <List
            title={ t('Users') }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ searchKeys }
        />
    )
}

UsersList.propTypes = {
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}

UsersList.defaultProps = {
    dataSelector : users.getAll,
    dataURL      : 'users'
}

export default translate()(connect()(UsersList))
